<template>
    <div>
        <json_editor_value 
            :multiple="multiple"
            :config_columns="config_columns"
            :action_columns_picking="action_columns_picking" 
            :data="c_data" 
            :level="1" 
            @get="get" 
            :index="index"
            :id_action="id_action" />
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";
	import draggable from "vuedraggable";

    import json_editor_value from "./json_editor_value";
    import store from "../store";

	var clone = require("clone");

    export default {
        name: "json_editor",
        components: {
            draggable,
            json_editor_value
        },
        props: {
            data: {},
            id_action: {},
            action_columns_picking: {
                default: () => {}
            },
            config_columns: {
                default: () => {}
            },
            index: {},
            multiple: {
                default: false
            }
        },
        watch: {
            action_columns_picking: {
                deep: true,
                handler()
                {
                    console.log("action_columns_picking")
                }
            },
            data: {
                deep: true,
                immediate: true,
                handler()
                {
                    
                    this.c_data = clone(this.data);
                    if (!this.c_data)
                        this.c_data = "Pas de données";
                    else if (typeof this.c_data == "string")
                        this.c_data = JSON.parse(this.c_data.replaceAll("\\n", "\n"));

                    //console.log(this.c_data)
                }
            }
        },
        data: function () {
            return {
                c_data: {},
                id: uniqueId()				
            };
		},
		methods: {
            get(elem, idx, id, multiple)
            {
                //console.log(elem);
                this.$emit("get", elem, idx, id, multiple);
            }
        },
		mounted: function () {
		}
    }

</script>